const typOsobySelect = [
    {
        value: '1',
        labelcz: 'FYZICKA_OSOBA'
    },
    {
        value: '2',
        labelcz: 'PRAVNICKA_OSOBA'
    }
];

export default typOsobySelect;
